import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { EntityPagedRequestParameters, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { RecuperacaoCredito } from 'src/app/model/recuperacao-credito.model';
import { ResolucaoInconsistenciaRecuperacaoCredito } from '../../../model/recuperacao-credito.model';
import { RecuperacaoCreditoService } from './recuperacao-credito.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';


@Component({
    selector: 'app-recuperacao-credito-listagem',
    templateUrl: './recuperacao-credito-listagem.component.html',
    styleUrls: ['./recuperacao-credito-listagem.component.scss'],
    standalone: false
})
export class RecuperacaoCreditoListagemComponent implements OnInit {

  private agentesFinanceiros: AgenteFinanceiro[] = [];

  @Input() public recuperacoesCredito: RecuperacaoCredito[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Input() public ehAgenteFinanceiro: boolean;
  @Input() public mostrarDatasValores: boolean;
  @Input() public mostrarFiltroPendencias: boolean;
  @Input() public tipoPendencia: string;
  @Input() public estadoFiltroPendencias: any;

  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public mudancaFiltroSomenteResolvidas: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  @Input() public mostrarExportarRecuperacoes: boolean;
  @Output() public aoExportarRecuperacoes: EventEmitter<any> = new EventEmitter<any>();

  public comPendencia: boolean;
  public podeEditar: boolean;

  constructor( private activatedRoute: ActivatedRoute,
    private service: RecuperacaoCreditoService,
    private alertService: BnAlertsService,
    private permissaoService: PermissaoService) {
    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; // resolver
  }

  ngOnInit(): void {
    if (this.mostrarExportarRecuperacoes == undefined) {
          this.mostrarExportarRecuperacoes = true;
    }
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeEditar = resp && resp[ROLE_GESTOR_ENVIO];
    });
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  trocaOpcaoComPendencias(comPendenciaStr) {
    if (comPendenciaStr == 'undefined') {
      this.comPendencia = undefined;
    }
    else if (comPendenciaStr == 'false') {
      this.comPendencia = false;
    }
    else {
      this.comPendencia = true;
    }
    this.mudancaFiltroSomenteResolvidas.emit(this.comPendencia == undefined ? undefined : !this.comPendencia);
  }

  public opcoesPaginacao: number[];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.recuperacoesCredito = this.recuperacoesCredito.sort((a, b) => {
      if (ord.sentido === 'asc') {
        return this.compara(a, b, ord.atributo);
      } else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  public mostrarCamposInclusaoResolucao(recuperacao: any) {
    recuperacao.resolucaoEmExibicao = undefined;
    recuperacao.deveMostrarCamposInclusaoResolucao = true;
  }

  public mostrarCamposExibicaoResolucao(recuperacao: any) {
    if (!recuperacao.resolucaoEmExibicao) {
      recuperacao.resolucaoEmExibicao = this.buscaResolucao(recuperacao);
    }
    else {
      recuperacao.resolucaoEmExibicao = undefined;
    }
  }

  public esconderCamposInclusaoResolucao(recuperacao: any) {
    recuperacao.deveMostrarCamposInclusaoResolucao = false;
    recuperacao.observacoesInclusaoResolucao = undefined;
  }

  public incluirResolucao(recuperacao: RecuperacaoCredito, observacoes: string) {
    let dto = new ResolucaoInconsistenciaRecuperacaoCredito();
    dto.estado = "CADASTRADA";
    dto.tipoInconsistenciaRecuperacaoCredito = this.tipoPendencia;
    dto.ideRecuperacaoCredito = recuperacao.id;
    dto.observacoes = observacoes;
    this.service.salvarResolucaoPendencia(dto).subscribe((resolucao) => {
      if (!recuperacao.resolucoes) {
        recuperacao.resolucoes = [];
      }
      recuperacao.resolucoes.push(resolucao);
      this.esconderCamposInclusaoResolucao(recuperacao);
      this.trocaOpcaoComPendencias(this.estadoFiltroPendencias[this.tipoPendencia]);
      this.alertService.alertaSucesso("Sucesso", "Resolução de inconsistência incluída com sucesso");
    });
  }

  public excluirResolucao(recuperacao: RecuperacaoCredito) {
    let resolucao = this.buscaResolucao(recuperacao);
    let dto: any = {...resolucao};
    dto.estado = "EXCLUIDA"; 
    this.service.salvarResolucaoPendencia(dto).subscribe((retorno) => {
      resolucao.estado = "EXCLUIDA";
      this.trocaOpcaoComPendencias(this.estadoFiltroPendencias[this.tipoPendencia]);
      this.alertService.alertaSucesso("Sucesso", "Resolução de inconsistência excluída com sucesso");
    });
  }

  public existePendencia(recuperacao: RecuperacaoCredito): boolean {
    return this.buscaResolucao(recuperacao) == undefined;
  }

  private buscaResolucao(recuperacao: RecuperacaoCredito): ResolucaoInconsistenciaRecuperacaoCredito {
    if (!recuperacao.resolucoes) {
      return undefined;
    }

    for (let resolucao of recuperacao.resolucoes) {
      if (resolucao.estado == "CADASTRADA" && resolucao.tipoInconsistenciaRecuperacaoCredito == this.tipoPendencia) {
        return resolucao;
      }
    }

    return undefined;
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) === this.fetchFromObject(b, atributo)) {
      return 0;
    } else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      } else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if (typeof obj === 'undefined') {
      return false;
    }

    const _index = prop.indexOf('.');
    if (_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  public nomeAgente(cnpj: string) {
    const agentes = this.agentesFinanceiros.filter(item => item.cnpj === cnpj);
    return agentes.length > 0 ? agentes[0].nome : `agente cnpj ${cnpj} desconhecido.`;
  }

  public exportarRecuperacoesCredito(): void {
    this.aoExportarRecuperacoes.emit();
  }
}
